module.exports = __webpack_public_path__ + "img/a6.7df6688e.png";